import { Component, OnInit, Input, EventEmitter, Output, OnChanges, OnDestroy } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { first } from 'rxjs/operators';
import { SnapshotDialogComponent, SnapshotDialogData } from './snapshot.dialog';
import { filterPageTypes } from 'src/app/store/filters.era';
import { prepareAndGetTimelineData } from 'src/app/modules/program/program.helpers';
import { Dictionary } from '@ngrx/entity';
import { ViewSessionDialogComponent, ViewSessionDialogData } from 'src/app/modules/onsiteschedule/onsite.dialog.viewSession.component';
import { ViewProgramDialogComponent } from 'src/app/modules/onsiteschedule/onsite.dialog.viewProgram.component';
import { jsonCopyObject,  makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { timelineParents, saveLocal, loadLocal } from 'src/app/helpers/helpers';
import { JoiEvent, LabelMaps, makeEmptyLabelMaps } from 'src/app/store/events.era';
import { Performer, PerformerDisplayType, performerDisplayTypes } from 'src/app/store/performers.era';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { Sponsor } from 'globals/store/sponsors.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Program } from 'globals/store/programs.data';
import { Ranking } from 'globals/store/events.data';
import { IconComponent } from '../icon/icon.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { LabelItemComponent } from '../label-marker/label-item.component';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { InputEditorComponent } from '../joi-input/input-editor';
import { ExpandableBarWrapperComponent } from '../wrappers/expandable-bar-wrapper.component';
import { TimelineItemComponent } from './timeline-item.component';
import { MultiTimelineColumnComponent } from './multi-timeline-column.component';
import { WithLabelsPipe } from 'src/app/services/pipes/withLabels.pipe';
import { TimelineStartPipe } from 'src/app/services/pipes/timelineStart.pipe';

@Component({
    selector: 'event-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss', './snapshot.scss'],
    standalone: true,
    imports: [IconComponent, TimelineStartPipe, WithLabelsPipe, MultiTimelineColumnComponent, TimelineItemComponent, MatProgressSpinnerModule, CommonModule, MatMenuModule, LabelItemComponent, ExpandingWrapperComponent, InputEditorComponent, ExpandableBarWrapperComponent, ],
})
export class TimelineComponent extends Wrapper<TimelineComponent> implements OnInit, OnChanges, OnDestroy {

  @Input() data: any = {};
  @Input() readonly;
  @Input() parent;
  @Output() filter: EventEmitter<void> = new EventEmitter();
  @Output() increment: EventEmitter<any> = new EventEmitter();
  @Output() editFacilitatorNotes: EventEmitter<{ event: Event, programId: string, sessionId?: string }> = new EventEmitter()

  performerDisplayTypes = performerDisplayTypes;
  @Input() performerDisplayType: PerformerDisplayType = performerDisplayTypes.listOnly // might need to turn this into an input
  @Input() staticPerformerData = null
  readonly api = `${environment.functionsURL}api/app`;
  event: JoiEvent;
  single_column: any;
  multiple_column: any;
  timeline_programs;
  timelineViews: { [key: string]: "expand" | "collapse"; } = {};
  program_legend = {};
  comma = ', ';
  title;
  showSnapshotMenu = false;
  timestamp;
  template;
  labels;
  labelTemplate;
  label_template: any = { program: [], session: [] };
  snapshot_view = false;
  snapshot_saving = false;
  snapshot_loading = false;
  facilitator_view = false;
  actualFilterCount: number
  programs: Program[] = []
  programEntities: Dictionary<Program>
  programTexts: { [pId: string]: string }
  labelMaps: LabelMaps = makeEmptyLabelMaps()
  performers: { [pId: string]: Performer } = {}
  sponsors: { [sId: string]: Sponsor } = {}

  collapsedStates: { [id: string]: boolean } = {}
  performerRoles: Dictionary<Ranking>
  
  @Input() defaultDetailedMode = true
  detailedMode = true
  timelineMode: 'single' | 'multiple' = 'single'

  constructor() {
    super()
    this.subProp(this.store.select('filters', filterPageTypes.programTimeline, 'count'), 'actualFilterCount')
    this.subProp(this.store.select('events','labelMaps'), 'labelMaps')

  }
  ngOnInit() {
    
    // console.log({ eventTimeline: this })
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')
    this.subCallback(this.store.select('events', 'event'), event => {
      this.event = event
      this.performerRoles = makeMapFromListOfObjectsAndKey(event.performerRoles, 'id')
    })
    this.subCallback(this.store.select('programs','entities'), programEntities => {
      this.programs = Object.values(programEntities)
      this.programEntities = programEntities
    })
    this.loadModes()

    if (this.parent === timelineParents.program) { 
      this.single_column = this.data.single_column;
      this.multiple_column = this.data.multiple_column;
      this.title = this.data.title;
      this.showSnapshotMenu = true;
      this.label_template = {
        program: this.event.program_labels || this.uiService.defaultLabels,
        session: this.event.session_labels || this.uiService.defaultLabels
      };
      // console.log('this.label_template', this.label_template)
    } else if (this.parent === timelineParents.facilitator) {
      this.facilitator_view = true;
      this.single_column = this.data.single_column;
      this.multiple_column = this.data.multiple_column;

      this.label_template = {
        program: this.event.program_labels || this.uiService.defaultLabels,
        session: this.event.session_labels || this.uiService.defaultLabels
      }
    } else if (this.data.columns) {
      this.single_column = this.data.columns.single_column;
      this.multiple_column = this.data.columns.multiple_column;
      this.template = this.data.template;
      this.title = this.data.name;
      this.timestamp = this.data.timestamp;
      this.label_template = { program: this.data.template.program, session: this.data.template.session };
      this.timeline_programs = this.timelineMode === 'single' ? this.single_column : this.multiple_column
    } 
    if (this.timeline_programs) {
      this.timeline_programs.forEach((pg, i) => {
        this.timelineViews[i] = 'expand';
        if (pg.sessions) {
          pg.sessions.forEach((ps, j) => {
            this.timelineViews[i + '_' + j] = 'expand';
          });
        }
      });
    }
  }

  trackByFn(index, item) { return index; }
  
  takeSnapshot(ev) {
    ev.stopPropagation();
    this.snapshot_saving = true;
    this.store.pipe(first()).subscribe(({ filters, workforce }) => {
      const { programTimeline, tempCounts } = filters
      const { workersByEmail } = workforce
      const { single_column, multiple_column, performerIdsBySessionIds, performerStatusBySessionIds } = prepareAndGetTimelineData(this.programs, [], this.event) // unfiltered version
      this.eventService.saveSnapshot(
        { single_column, multiple_column },
        programTimeline,
        tempCounts[filterPageTypes.programTimeline],
        this.event,
        workersByEmail,
        { 
          performers: this.performers,
          performerIdsBySessionIds,
          performerStatusBySessionIds
        }
      ).then(() => this.snapshot_saving = false)
    })
  }


  loadModes() {
    this.detailedMode = loadLocal(`${this.parent}detailedMode`)
    this.detailedMode = this.detailedMode === null ? this.defaultDetailedMode : this.detailedMode
    this.timelineMode = loadLocal(`${this.parent}timelineMode`, this.timelineMode)
    this.timeline_programs = this.timelineMode === 'single' ? this.single_column : this.multiple_column
  }

  toggleDetails(detailed) {
    saveLocal(`${this.parent}detailedMode`, detailed)
    this.detailedMode = detailed
  }
  
  toggleView(mode) {
    saveLocal(`${this.parent}timelineMode`, mode)
    this.timelineMode = mode
    this.timeline_programs.forEach((pg, i) => this.timelineViews[i] = 'expand');
    this.timeline_programs = this.timelineMode === 'single' ? this.single_column : this.multiple_column
  }

  toggleExpanded(id) {
    this.collapsedStates[id] = !this.collapsedStates[id]
  }

  collapseAll() {
    this.timeline_programs.forEach(p => {
      this.collapsedStates[p.programId + 'notes'] = true
      this.collapsedStates[p.programId ] = true
      p.sessions.forEach(s => {
        this.collapsedStates[s.sessionId + 'notes'] = true
        this.collapsedStates[s.sessionId] = true
      })
    })
  }

  expandAll() {
    this.collapsedStates = {}
  }

  collapseAllNotes() {
    this.timeline_programs.forEach(p => {
      this.collapsedStates[p.programId + 'notes'] = true
      p.sessions.forEach(s => {
        this.collapsedStates[s.sessionId + 'notes'] = true
      })
    })
  }

  expandAllNotes() {
    Object.keys(this.collapsedStates).filter(k => k.includes('notes')).forEach(k => this.collapsedStates[k] = false)
  }

  popupSnapshot(shot) {
    this.snapshot_loading = true;
    const data: SnapshotDialogData = { snapshotId: shot.id, setClassSnapshotOpenInTimeline: this.setClassSnapshotOpenInTimeline.bind(this) }
    openDialogGetResult(this.dialog, SnapshotDialogComponent, {
      maxWidth: '100vw',
      width: '100vw',
      height: '100%',
      panelClass: 'snapshot-panel',
      data
    }).then(_ => this.setClassSnapshotOpenInTimeline(false))
  }

  setClassSnapshotOpenInTimeline(add) { // has to do with print formatting as much as loading
    // console.log(`setSnapshotOpenClassCalled, add: ${add}`)
    if (add) {
      this.snapshot_view = true
      this.snapshot_loading = false
      document.body.classList.add('snapshot-open')
    } else {
      this.snapshot_view = false
      this.snapshot_loading = false // to be safe
      document.body.classList.remove('snapshot-open')
    }
  }

  openSessionDetail(session, singleOrMultitimelineProgram, date) {
    // console.log({ session, singleOrMultitimelineProgram, date, mode: this.mode, data: this.data })
    if (!session.pID || !session.sessionId) return;
    if (this.parent !== timelineParents.snapshot) {
      // apparently this is the "normal setting"
      // console.log("Not in snapshot mode, opening session detail")
      const program = this.programEntities[session.pID]
      // console.log( { date, session, program, data: this.data, programEntities: this.programEntities })
      if (program) {
        const data: ViewSessionDialogData = {
          program,
          session: program.sessions_obj[session.sessionId],
          date
        }
        this.dialog.open(ViewSessionDialogComponent, {
          width: '480px',
          maxHeight: '90vh',
          data
        });
      } else {
        console.log("Program not found for session!", { session, program })
      }
    } else { // snapshot mode
      // console.log("In snapshot mode, opening session detail")
      const sessions = this.single_column.map(col => [...col.sessions]).reduce((acc, cur) => acc.concat(cur));
      // console.log('openSessionDetail', session.pID, this.single_column)
      let sess = sessions.find(se => se.sessionId === session.sessionId);
      sess = { ...sess, labels: sess.sess_labels, label_template: this.label_template.session }

      let program
      if (singleOrMultitimelineProgram.date) {
        const m = this.multiple_column.filter(m => m.id === singleOrMultitimelineProgram.id)
        if (!m.length) {
          console.log("could not find timeline holder for snapshot data program!", { this: this, singleOrMultitimelineProgram, session })
          return
        }
        program = m[0].programs.find(p => p.pID === sess.pID)
        if (!program) {
          console.log("could not find snapshot data program!", { this: this, singleOrMultitimelineProgram, sess: jsonCopyObject(sess), m: jsonCopyObject(m) })
          return
        }
      } else {
        program = singleOrMultitimelineProgram
      }
      // console.log({ program, session, date })
      const data: ViewSessionDialogData = {
        program,
        session: sess,
        date
      }
      this.dialog.open(ViewSessionDialogComponent, {
        width: '480px',
        maxHeight: '90vh', autoFocus:false,
        data
      });
    }
  }

  openProgramDetail(prog) {
    console.log('prog ', prog);
    if (!prog.labels) prog.labels = prog.prog_labels ? prog.prog_labels : [];
    prog.label_template = this.label_template.program;
    this.dialog.open(ViewProgramDialogComponent, { width: '480px', maxHeight: '90vh', data: prog });
  }

  ngOnChanges(changes) {
    if (changes.data && changes.data.currentValue && changes.data.currentValue.name) {
      this.single_column = changes.data.currentValue.columns.single_column;
      this.multiple_column = changes.data.currentValue.columns.multiple_column;
      this.template = changes.data.currentValue.template;
      this.title = changes.data.currentValue.name;
      this.timestamp = changes.data.currentValue.timestamp;
      this.label_template = { program: changes.data.currentValue.template.program, session: changes.data.currentValue.template.session };

      this.single_column.forEach((pg, i) => this.timelineViews[i] = 'expand');

    } else if (changes.data && changes.data.currentValue) {
      this.single_column = changes.data.currentValue.single_column;
      this.multiple_column = changes.data.currentValue.multiple_column;
      this.title = changes.data.currentValue.title;
    }
    if (this.data && !this.data.program_legend && this.multiple_column) {
      this.data.program_legend = {};
      this.multiple_column.forEach(col => {
        if (col.programs) {
          col.programs.forEach(prog => this.data.program_legend[prog.pID] = prog)
        }
      });
    }
    // console.log('this.data.program_legend', this.data.program_legend);
    if (this.timelineMode === 'single') {
      this.timeline_programs = this.single_column
    } else if (this.timelineMode === 'multiple') {
      this.timeline_programs = this.multiple_column;
    }
    // console.log('data changed', changes.data.currentValue)
  }

  toggleAll(action, type) {
    const that = this;
    Object.keys(this.timelineViews).forEach(function (key) {
      if (key.indexOf('_') < 0) {
        if (type === 'days') {
          that.timelineViews[key] = action;
        }
      } else {
        if (type === 'programs') {
          that.timelineViews[key] = action;
        }
      }
    });
  }
}

